export default __webpack_public_path__ + "static/palarkoffice-edb219dda93226ac9f9a9a03451f11a0.png";